angular.module("UI8.components").component("shotComposer", {
  template: `<div class="shotc" ng-if="$ctrl.allowed">
      <div class="shotc__container container">
        <h1 class="shotc__title">{{ $ctrl.editing ? 'Edit shot' : 'Post a shot' }}</h1>

        <div class="shotc__images">
          <div class="shotc__thumb" ng-repeat="image in $ctrl.images track by $index" ng-style="{'background-color': image.color}">
            <img ng-src="{{ $ctrl.thumbUrl(image) }}" alt="">
            <button class="shotc__remove" type="button" ng-click="$ctrl.removeImage($index)" aria-label="Remove image">&times;</button>
          </div>
          <div class="shotc__uploading" ng-repeat="file in $ctrl.allFiles" ng-if="file.processing">
            <div class="shotc__progress"><span ng-style="{width: (file.progress || 0) + '%'}"></span></div>
          </div>
          <div class="shotc__tilewrap" ng-if="$ctrl.images.length < 4">
            <div class="shotc__tile"
                 ng-model="$ctrl.batch" ui8-upload ngf-multiple="true"
                 ui8-upload-max-size="15000" accept=".png,.jpg,.jpeg"
                 ui8-upload-complete="$ctrl.uploadTick">
              <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>
              <span>{{ $ctrl.images.length ? 'Add image' : 'Upload images' }}</span>
            </div>
          </div>
        </div>
        <div class="shotc__hint">Up to 4 images, PNG or JPG. The first one is the cover.</div>

        <div class="shotc__field">
          <label class="shotc__label" for="shot-title">Title</label>
          <input class="shotc__input" id="shot-title" type="text" maxlength="80" ng-model="$ctrl.title" placeholder="What did you make?">
        </div>

        <div class="shotc__field">
          <label class="shotc__label" for="shot-description">Description</label>
          <textarea class="shotc__input shotc__input--area" id="shot-description" maxlength="1000" ng-model="$ctrl.description" placeholder="The story, the process, the details (optional)"></textarea>
        </div>

        <div class="shotc__field">
          <label class="shotc__label" for="shot-tags">Tags</label>
          <input class="shotc__input" id="shot-tags" type="text" ng-model="$ctrl.tagsInput" placeholder="ui, mobile, dashboard (comma separated)">
        </div>

        <div class="shotc__field" ng-if="$ctrl.products.length">
          <label class="shotc__label" for="shot-product">Attach a product</label>
          <select class="shotc__input shotc__input--select" id="shot-product" ng-model="$ctrl.productId"
                  ng-options="p._id as p.name for p in $ctrl.products">
            <option value="">None</option>
          </select>
          <div class="shotc__hint">Made with one of your products? Link it under the shot.</div>
        </div>

        <div class="shotc__error" ng-if="$ctrl.error">{{ $ctrl.error }}</div>

        <div class="shotc__actions">
          <button class="btn btn--submit" ng-click="$ctrl.save()" ng-disabled="!$ctrl.canSave()">
            {{ $ctrl.saving ? 'Saving…' : ($ctrl.editing ? 'Save changes' : 'Publish shot') }}
          </button>
          <a class="btn btn--stroke" ng-href="{{ $ctrl.cancelLink }}">Cancel</a>
          <span class="shotc__spacer" ng-if="$ctrl.editing"></span>
          <button class="btn btn--stroke shotc__delete" ng-if="$ctrl.editing && !$ctrl.confirmDelete" ng-click="$ctrl.confirmDelete = true">Delete shot</button>
          <button class="btn btn--stroke shotc__delete is-armed" ng-if="$ctrl.editing && $ctrl.confirmDelete" ng-click="$ctrl.remove()">Really delete?</button>
        </div>
      </div>
    </div>
    <div class="spage" ng-if="!$ctrl.allowed">
      <div class="spage__container">
        <div class="spage__title">{{ $ctrl.gateTitle }}</div>
        <div class="spage__content">{{ $ctrl.gateText }}</div>
        <a href="/authors" class="btn btn--submit" ng-if="!$ctrl.editing">Become an author</a>
        <a href="/shots" class="btn btn--stroke">Back to shots</a>
      </div>
    </div>`,

  controller: function ($scope, $window, ShotService) {
    var ctrl = this;

    var S3_IMAGE_SERVER = "https://images.ui8.net";

    ctrl.$onInit = function () {
      // Edit state resolves `shot` (null when the lookup failed); the
      // create state doesn't bind it at all
      ctrl.editing = ctrl.shot !== undefined;
      ctrl.allowed = ctrl.editing
        ? !!(ctrl.shot && ctrl.shot.can_edit)
        : !!(ctrl.permissions && ctrl.permissions.can_post);
      ctrl.products = (ctrl.permissions && ctrl.permissions.products) || [];

      ctrl.gateTitle = ctrl.editing
        ? "This shot can't be edited."
        : "Shots posting is for UI8 authors right now.";
      ctrl.gateText = ctrl.editing
        ? "It may have been removed, or it isn't yours."
        : "Sell your work on UI8 and your shots ride along for free.";

      ctrl.images = [];
      ctrl.batch = [];
      // Each file selection replaces ctrl.batch, so completed and
      // in-flight uploads are tracked in a cumulative list instead
      ctrl.allFiles = [];
      $scope.$watch(
        function () {
          return ctrl.batch;
        },
        function (files) {
          (files || []).forEach(function (file) {
            if (ctrl.allFiles.indexOf(file) === -1) ctrl.allFiles.push(file);
          });
        }
      );
      ctrl.title = "";
      ctrl.description = "";
      ctrl.tagsInput = "";
      ctrl.productId = "";
      ctrl.saving = false;
      ctrl.error = null;
      ctrl.cancelLink = "/shots";

      if (ctrl.editing && ctrl.allowed) {
        ctrl.title = ctrl.shot.title;
        ctrl.description = ctrl.shot.description || "";
        ctrl.tagsInput = (ctrl.shot.tags || []).join(", ");
        ctrl.productId =
          (ctrl.shot.product && (ctrl.shot.product._id || ctrl.shot.product)) ||
          "";
        ctrl.images = (ctrl.shot.images || []).map(function (i) {
          return {
            url: i.url,
            width: i.width,
            height: i.height,
            color: i.color,
            resized: i.resized,
            version: i.version,
            _id: i._id,
          };
        });
        ctrl.cancelLink = "/shots/" + ctrl.shot.slug;
      }
    };

    // Thumbnails: card rendition once processed, the raw upload before
    ctrl.thumbUrl = function (image) {
      if (image.resized && ctrl.editing) {
        return (
          S3_IMAGE_SERVER +
          "/shot/" +
          ctrl.shot._id +
          "/" +
          image._id +
          "_card_" +
          image.version +
          ".webp"
        );
      }
      return image.url;
    };

    ctrl.removeImage = function (index) {
      ctrl.images.splice(index, 1);
    };

    // Fired by ui8-upload after each file lands on S3: collect finished
    // uploads into the image list with their natural dimensions
    ctrl.uploadTick = function () {
      (ctrl.allFiles || []).forEach(function (file) {
        if (!file.completed || file.added || file.error) return;
        file.added = true;

        if (ctrl.images.length >= 4) return;

        var objectUrl = $window.URL.createObjectURL(file);
        var probe = new Image();
        probe.onload = function () {
          $scope.$applyAsync(function () {
            if (ctrl.images.length < 4) {
              ctrl.images.push({
                url: file.url,
                width: probe.naturalWidth,
                height: probe.naturalHeight,
              });
            }
          });
          $window.URL.revokeObjectURL(objectUrl);
        };
        probe.onerror = function () {
          $scope.$applyAsync(function () {
            if (ctrl.images.length < 4) {
              ctrl.images.push({ url: file.url });
            }
          });
          $window.URL.revokeObjectURL(objectUrl);
        };
        probe.src = objectUrl;
      });
    };

    function uploading() {
      return (ctrl.allFiles || []).some(function (f) {
        return f.processing;
      });
    }

    ctrl.canSave = function () {
      return (
        !ctrl.saving &&
        !uploading() &&
        !!(ctrl.title || "").trim() &&
        ctrl.images.length > 0
      );
    };

    ctrl.save = function () {
      if (!ctrl.canSave()) return;

      ctrl.saving = true;
      ctrl.error = null;

      var payload = {
        title: (ctrl.title || "").trim(),
        description: (ctrl.description || "").trim(),
        tags: (ctrl.tagsInput || "")
          .split(",")
          .map(function (t) {
            return t.trim();
          })
          .filter(Boolean),
        images: ctrl.images.map(function (i) {
          return { url: i.url, width: i.width, height: i.height };
        }),
        product: ctrl.productId || null,
      };

      var request = ctrl.editing
        ? ShotService.update(ctrl.shot._id, payload)
        : ShotService.create(payload);

      request
        .then(function (data) {
          $window.location = "/shots/" + data.slug;
        })
        .catch(function (res) {
          ctrl.saving = false;
          ctrl.error =
            (res && res.data && res.data.error) ||
            "Something went wrong. Please try again.";
        });
    };

    ctrl.remove = function () {
      if (ctrl.saving) return;
      ctrl.saving = true;

      ShotService.remove(ctrl.shot._id)
        .then(function () {
          $window.location = "/shots";
        })
        .catch(function () {
          ctrl.saving = false;
          ctrl.confirmDelete = false;
          ctrl.error = "Unable to delete this shot right now.";
        });
    };
  },

  bindings: {
    user: "<",
    permissions: "<",
    shot: "<?",
  },
});
